import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { concatenateUrl } from '../../../common/support/api'
import { RestService } from '../../../common/services/rest/Rest.service'
import { Cadastro } from "../../../lib/models/Cadastro"
const service = {
  name: 'UsuarioController',
  url: 'UsuarioController'
}

@Injectable({
  providedIn: 'root'
})
export class FormularioService extends RestService<Cadastro> {
  private readonly API_URL = concatenateUrl(service.url)

  enviarDados(dados): Observable<any> {


    return this.criar(this.API_URL, dados)

  }

  receberUnidade(dados): Observable<any> {


    return this.criar(this.API_URL + '/obterUnidade', dados)

  }

  verificarCNPJCadastrado(dados): Observable<any> {

    return this.criar(this.API_URL + '/verificarCadastro', dados)

  }
  obterUsuario(dados): Observable<any> {
    console.log("DADOS")
    console.log(dados)
    return this.criar(this.API_URL + '/obterNomeDeUsuarioSemToken', dados)

  }



}

